$(function() {
    displayChoosing($('.js-radio-price:checked'));

    $('.js-radio-price').on('change', function() {

        $('.js-radio-price:checked').not(this).prop('checked', false);

        displayChoosing(this);
    });

    $(window).resize(() => displayChoosing($('.js-radio-price:checked')));
});

function displayChoosing(el) {
    const indicator = $(el).siblings('.js-radio-label-price').html();

    if (!$(el).is(':checked') || $(document).width() < 768) {
        $(el).closest('.js-options').siblings('.js-options-btn')
                .find('.js-options-price').html('Price');

        return;
    }

    $(el).closest('.js-options').siblings('.js-options-btn')
        .find('.js-options-price').html(indicator);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/radio.js